export const CONTEXT_TYPE = {
  individual: 1,
  invites: 5,
};